import {Input} from 'antd'

import {Button, Form, FormItem, Text} from 'common/components'
import {useInputFocus} from 'common/hooks'
import {FIELD_RULES} from 'common/constants'
import {IDocument, useRenameDocument} from '..'

interface DocumentRenameFormProps {
  document: IDocument
  projectUuid: string
  onClose: () => void
}

export default function DocumentRenameForm({
  document,
  projectUuid,
  onClose,
}: DocumentRenameFormProps) {
  const {mutate: renameDocument, isMutating} = useRenameDocument(
    document.uuid,
    projectUuid,
    onClose
  )
  const inputRef = useInputFocus()

  const nameParts = document.name.split('.')

  const hasExtension = nameParts.length > 1

  const nameValue = hasExtension
    ? nameParts.slice(0, nameParts.length - 1).join('')
    : document.name

  const suffixLabel = hasExtension ? `.${nameParts.at(-1)}` : null

  const handleFinish = ({name}: any) =>
    renameDocument({
      name: hasExtension ? `${name}${suffixLabel}` : name,
    })

  const intialValues = {name: nameValue}

  return (
    <Form initialValues={intialValues} onFinish={handleFinish}>
      <FormItem name="name" label="Title" rules={FIELD_RULES}>
        <Input
          ref={inputRef}
          suffix={
            suffixLabel ? (
              <Text as="span" color="grey">
                {suffixLabel}
              </Text>
            ) : undefined
          }
        />
      </FormItem>
      <Button block htmlType="submit" loading={isMutating}>
        Save
      </Button>
    </Form>
  )
}
